<template>
  <div>
    <p v-if="label" class="body-2">{{ label }}</p>
    <div v-for="(file, i) in files" :key="`file-${i}`" class="d-flex">
      <input ref="fileUpload" type="file" class="file-upload-file-input" @change="fileUploadHandler($event, i)" />
      <v-text-field v-model="file.file" disabled class="file-upload-file-path"> </v-text-field>
      <v-btn text class="file-upload-select-button" @click="openFileDialog(i)">
        {{ $t('Select_file') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LimitedFileInput',
  props: {
    label: {
      type: String,
      default: () => '',
    },
    filesCount: {
      type: Number,
      default: () => 3,
    },
  },
  data() {
    return {
      files: Array.from({ length: this.filesCount }, () => ({ file: '' })),
    }
  },
  methods: {
    cleanup() {
      this.$refs.fileUpload.forEach((f) => {
        f.value = ''
      })
      this.files.forEach((f) => {
        f.file = ''
      })
    },
    fileUploadHandler(e, index) {
      // Set the filename in the correct display field.
      const { files } = e.target
      this.files[index].file = files.length ? files[0].name : ''
    },
    openFileDialog(index) {
      // Open the file dialog of the correct upload field.
      this.$refs.fileUpload[index].click()
    },
  },
}
</script>

<style lang="scss" scoped>
.file-upload-select-button {
  position: relative;
  overflow: hidden;
  margin: 10px 0 10px 10px;
}
.file-upload-file-input {
  display: none;
}
</style>
